import 'leaflet/dist/leaflet.css';

import { AdminContainer } from '@/components/containers';
import { FarmsTable } from '@/components/tables/farms-table.component';
import { cn } from '@/lib/utils';
import { useProject } from '@/modules/Customers/Customers.api';
import { IfPermitted, UserPermissions } from '@/modules/Permissions';
import { useParams } from 'react-router-dom';

function FarmsList() {
  const { projectId = '' } = useParams<{ projectId: string }>();
  const { data: project } = useProject(projectId);

  let title = project ? project.project_name : 'Farms';
  title = !projectId ? 'Farms' : title;

  return (
    <IfPermitted permissions={[UserPermissions.FARM_LIST]}>
      <AdminContainer className={cn('flex flex-col')} title={title} breadcrumbData={project?.breadcrumb}>
        <FarmsTable />
      </AdminContainer>
    </IfPermitted>
  );
}

export default FarmsList;
